import React from "react";
import GlobalStyles from "styles/GlobalStyles";

import NotFoundPage from "pages/404.js";
import TermsOfServicePage from "pages/TermsOfService.js";
import PrivacyPolicyPage from "pages/PrivacyPolicy.js";
import Insurance from "pages/Insurance.js";
import Information from "pages/Info.js";
import Groups from "pages/Group.js";
import Crew from "pages/Crew.js";
import SurfLifeLandingPage from "content/SurfLifeLandingPage";
import SeoHead from "seo/SeoHead";
import InfoBanner from "content/components/infoBanner";

import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { LanguageProvider } from "helpers/languageSelector";

export default function App() {
  return (
    <>
      <GlobalStyles />
      <LanguageProvider>
        <Router>
          <SeoHead />
          <InfoBanner />
          <Routes>
            <Route path="/" element={<SurfLifeLandingPage />} />

            {/* nl */}
            <Route path="/nl" element={<SurfLifeLandingPage />} />
            <Route path="/voorwaarden" element={<TermsOfServicePage />} />
            <Route path="/privacybeleid" element={<PrivacyPolicyPage />} />
            <Route path="/verzekering" element={<Insurance />} />
            <Route path="/informatie" element={<Information />} />
            <Route path="/groepsreizen" element={<Groups />} />
            <Route path="/crew-nl" element={<Crew />} />

            {/* en */}
            <Route path="/en" element={<SurfLifeLandingPage />} />
            <Route path="/termsAndCondition" element={<TermsOfServicePage />} />
            <Route path="/privacyPolicy" element={<PrivacyPolicyPage />} />
            <Route path="/insurance" element={<Insurance />} />
            <Route path="/information" element={<Information />} />
            <Route path="/groups" element={<Groups />} />
            <Route path="/crew" element={<Crew />} />

            {/* de */}
            <Route path="/de" element={<SurfLifeLandingPage />} />
            <Route path="/geschaftsbedingungen" element={<TermsOfServicePage />} />
            <Route path="/datenschutz" element={<PrivacyPolicyPage />} />
            <Route path="/Versicherung" element={<Insurance />} />
            <Route path="/informationen" element={<Information />} />
            <Route path="/gruppe" element={<Groups />} />
            <Route path="/crew-de" element={<Crew />} />

            {/* Legacy / duplicate URLs → canonical language routes */}
            <Route path="/terms-conditions" element={<Navigate to="/termsAndCondition" replace />} />
            <Route path="/contact" element={<Navigate to="/information" replace />} />
            <Route path="/home" element={<Navigate to="/en" replace />} />
            <Route path="/surf-camps" element={<Navigate to="/en" replace />} />
            <Route path="/surfcamp-mimizan" element={<Navigate to="/en" replace />} />
            <Route path="/surflife-founders" element={<Navigate to="/crew" replace />} />
            <Route path="/group-travel" element={<Navigate to="/groups" replace />} />

            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Router>
      </LanguageProvider>
    </>
  );
}